var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"docScroll",attrs:{"id":"pci-compliance"}},[_c('HeaderTemplate',{attrs:{"data":_vm.contentHeader}}),_c('SectionColumn',{attrs:{"type":"full","content":_vm.fullContent}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }